// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation EmailSalesOrderMutation($input: EmailSalesOrderInput!) {
    emailSalesOrder(input: $input) {
      success
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
